import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ChangeDetectorRef, HostBinding } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { User } from './Models/User';
import { UserService } from './services/user.service';
import { NavigationGuardService } from './services/navigation-guard.service';
import { VersionCheckService } from './services/version-check.service';
import { MatSnackBar } from '@angular/material/snack-bar';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  standalone: false
})

export class AppComponent implements OnInit {

  public shownScreen: string = "";

  public hasLoggedInUser = false;
  public loggedInUser = <User | undefined>{};
  public isAdminMenuOpen = false;
  public isClientPortalRoute = false;
  @HostBinding('class.portal-route') get portalRouteClass() { return this.isClientPortalRoute; }

  constructor(
    private http: HttpClient,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private userService: UserService,
    private navGuard: NavigationGuardService,
    private versionCheck: VersionCheckService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.isClientPortalRoute = window.location.pathname.startsWith('/client');
    this.router.events.pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: any) => {
        this.isClientPortalRoute = e.urlAfterRedirects.startsWith('/client');
      });

    this.versionCheck.startPolling();
    this.versionCheck.updateAvailable$.subscribe(() => {
      const snack = this.snackBar.open(
        'A new version of the app is available.',
        'Refresh now',
        { duration: 0 }
      );
      snack.onAction().subscribe(() => window.location.reload());
    });
  }

  logout() {
    this.navGuard.requestAction(() => this.doLogout());
  }

  private doLogout() {
    this.loggedInUser = undefined;
    this.hasLoggedInUser = false;
    this.userService.clearUser();
    this.router.navigate(['/']);
  }

  userIsAdmin() {
    return this.userHasRoleWithId(3);
  }

  isSystemAdministrator() {
    return this.userHasRoleWithId(1);
  }

  isSupervisor() {
    return this.userHasRoleWithId(2);
  }

  getUserInitials(): string {
    if (!this.loggedInUser) return '?';
    const first = this.loggedInUser.firstName?.charAt(0)?.toUpperCase() || '';
    const last = this.loggedInUser.lastName?.charAt(0)?.toUpperCase() || '';
    return first + last || '?';
  }

  userHasRoleWithId(id: number) {

    if (this.loggedInUser != undefined && this.loggedInUser.roles) {
      // Check if the user has a role with the specified ID
      if (this.loggedInUser.roles.some(role => role.id === id)) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return false;
    }
  }



  userLoggedInOrOutStatusChange(user: User | undefined) {

    this.loggedInUser = user;
    this.hasLoggedInUser = (user != undefined);
    
    // Store user in service for access by child components
    this.userService.setLoggedInUser(user);
    
    // Trigger change detection to ensure UI updates properly
    this.cdr.detectChanges();

  }

  navigateToScreen(screen: string) {
    this.navGuard.requestAction(() => this.doNavigateToScreen(screen));
  }

  private doNavigateToScreen(screen: string) {
    switch(screen) {
      case 'Home':
        this.router.navigate(['/'], { state: { user: this.loggedInUser } });
        break;
      case 'Reading':
        this.router.navigate(['/reading', '1656068303920013'], { state: { user: this.loggedInUser }});
        break;
      case 'Reporting':
        this.router.navigate(['/reporting', '1707316837118821'], { state: { user: this.loggedInUser } });
        break;
      case 'ProbateList':
        this.router.navigate(['/probate-list'], { state: { user: this.loggedInUser } });
        break;
      case 'CharityDatabase':
        this.router.navigate(['/charity-database'], { state: { user: this.loggedInUser } });
        break;
      case 'PAFMatching':
        // TODO: Add route when component is ready
        break;
      case 'AdminUsers':
        this.router.navigate(['/admin-users']);
        break;
      case 'AdminClients':
        this.router.navigate(['/admin-clients'], { state: { user: this.loggedInUser } });
        break;
      case 'AdminBeneficiaries':
        this.router.navigate(['/admin-beneficiaries']);
        break;
      case 'AdminUtilities':
        this.router.navigate(['/admin-utilities']);
        break;
      case 'Reports':
        this.router.navigate(['/reports'], { state: { user: this.loggedInUser } });
        break;
      default:
        this.router.navigate(['/']);
    }
  }

  title = 'charitycentral.client';
}


